import React from 'react';
import Logo from '../Logo/PrinterPeoplelogo.png';

const BillPrint = ({ onClose, labelData }) => {
    const containerStyle = {
        border: '1px solid #000',
        padding: '5px',
        width: '700px',
        height: '700px',
    };

    const printStyles = `
        @media print {
            body {
                margin: 10px;
            }
        }
    `;

    if (!labelData || labelData.length === 0) {
        return null;
    }

    const firstItem = labelData[0];

    const NumberToWords = (num) => {
        const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const teens = ['Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

        const convert = (num) => {
            if (num < 10) return units[num];
            if (num < 20) return teens[num - 11];
            if (num < 100) return tens[Math.floor(num / 10)] + ' ' + units[num % 10];
            if (num < 1000) return units[Math.floor(num / 100)] + ' Hundred ' + convert(num % 100);
            if (num < 10000) return units[Math.floor(num / 1000)] + ' Thousand ' + convert(num % 1000);
            return 'Number is too large';
        };

        if (num === 0) return 'Zero';
        return convert(num);
    };

    const AmountInWords = ({ amount }) => {
        const formattedAmount = parseFloat(amount).toFixed(2);
        const [rupees, decimal] = formattedAmount.split('.');

        return (
            <div>
                <h5>Rupees {NumberToWords(parseInt(rupees))} Only</h5>
                {decimal !== "00" && <p>{NumberToWords(parseInt(decimal))} Paise Only</p>}
            </div>
        );
    };

    return (

        <div style={containerStyle}>
            {labelData && (
                <>
                    <div>
                        <div style={{ textAlign: 'center', marginBottom: '0px' }}>
                            <img src={Logo} alt="Company Logo" style={{ maxHeight: '80px', margin: '0 auto', width: '100%', height: '75%' }} />
                        </div>
                        <br />
                        <h4 style={{ textAlign: 'center', marginTop: '1px', marginBottom: '0px' }}>RECEIPT</h4>
                    </div>

                    {firstItem && firstItem.ReceiptPrint && (
                        <div>
                            <div style={{ marginBottom: '5px', fontSize: '16px' }}>
                                <strong style={{ fontSize: '20px' }}>Customer: {firstItem.ReceiptPrint.Name}</strong>
                            </div>
                            <div style={{ marginBottom: '5px', fontSize: '16px' }}>
                                <strong style={{ fontSize: '20px' }}>Phone No: {firstItem.ReceiptPrint.ContactNumber}</strong>
                            </div>
                            <div style={{ textAlign: 'right', marginBottom: '5px', fontSize: '16px' }}>
                                <strong style={{ fontSize: '20px' }}>Receipt No: {firstItem.ReceiptPrint.ReceiptNo}</strong>
                            </div>
                            <div style={{ textAlign: 'right', marginBottom: '5px', fontSize: '16px' }}>
                                <strong style={{ fontSize: '20px' }}>Receipt Date: {new Date(firstItem.ReceiptPrint.ReceiptDate).toLocaleDateString('en-GB')}</strong>
                            </div>
                        </div>
                    )}

                    {firstItem && firstItem.ReceiptPrint && (
                        <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
                            <thead>
                                <tr>
                                    <th style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold' }}>Remarks</th>
                                    <th style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold' }}>Bill Amount</th>
                                    <th style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold' }}>Paid Amount</th>
                                    <th style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold' }}>Payment Mode</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold', color: 'black' }}>{firstItem.ReceiptPrint.Receiptremarks}</td>
                                    <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold', color: 'black' }}>{firstItem.ReceiptPrint.BillAmount}</td>
                                    <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold', color: 'black' }}>{firstItem.ReceiptPrint.TotalAmount}</td>
                                    <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold', color: 'black' }}>{firstItem.ReceiptPrint.Paymenttype}</td>
                                </tr>
                            </tbody>
                        </table>
                    )}

                    {firstItem && firstItem.ReceiptPrint && (
                        <AmountInWords amount={firstItem.ReceiptPrint.TotalAmount} />
                    )}
                </>
            )}
        </div>
    );
};

export default BillPrint;